export default "__VITE_ASSET__s2ighFSO__"